import { useAppSelector } from '@frontend/common';
import { SelectOption } from '@frontend/components/basic-forms';
import { EquipmentEnumClient } from '@frontend/equipment/api';
import { EquipmentTrigger, EquipmentTriggerName } from '@frontend/equipment/types';
import { fetchGeneralWorkflowTriggers, workflowSharedStore } from '@frontend/workflow/redux';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { EquipmentTriggerSelectProps } from './equipment-trigger-select.component';

interface ViewProps {
    options: SelectOption<EquipmentTriggerName>[];
}

const useEquipmentTriggerSelect = (props: EquipmentTriggerSelectProps): ViewProps => {
    const [triggers, changeTriggers] = useState<string[]>([]);
    const workflowSharedState = useAppSelector(useSelector, workflowSharedStore);

    useEffect(() => {
        props.dispatch && props.dispatch(fetchGeneralWorkflowTriggers());
        EquipmentEnumClient.fetchEquipmentTriggers().then(changeTriggers);
    }, []);

    const options = useMemo(() => {
        if (!triggers || !workflowSharedState.generalWorkflowTriggers) return [];
        return [...triggers, ...workflowSharedState.generalWorkflowTriggers].map((productTrigger) => {
            const found = EquipmentTrigger.ALL.find((t) => t.value === productTrigger);
            if (found) return { value: found.value, label: found.value, display: found.displayName };
            else
                return {
                    value: productTrigger,
                    label: productTrigger.replace(/_/g, ' ')
                };
        });
    }, [triggers, workflowSharedState.generalWorkflowTriggers]);

    return { options };
};

export default useEquipmentTriggerSelect;
